/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Companion World API
 * API for managing virtual worlds populated with AI-driven agents.

## Overview
The Companion World API provides endpoints for:
- Creating and managing virtual worlds
- Generating populations of AI agents
- Managing agent activities and calendars
- Configuring locations and demographics

## Authentication
Currently, the API operates without authentication. This will be updated in future versions.

## Async Operations
Long-running operations (like population generation) return job IDs for status polling.

 * OpenAPI spec version: 1.0.0
 */

export type DemographicsRelationshipStatus =
  (typeof DemographicsRelationshipStatus)[keyof typeof DemographicsRelationshipStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DemographicsRelationshipStatus = {
  single: 'single',
  married: 'married',
  divorced: 'divorced',
  widowed: 'widowed',
  partnered: 'partnered',
} as const;
